// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "addDocumentModal__modalContent-12Tbp";
var _3 = "addDocumentModal__modalHeader-2EQRM";
var _4 = "addDocumentModal__content-VoxzK";
var _5 = "addDocumentModal__field-3HQe_";
var _6 = "addDocumentModal__footer-3jUtM";
var _7 = "addDocumentModal__cancelButton-AOSIB";
var _8 = "addDocumentModal__clearButton-Nj505";
var _9 = "addDocumentModal__saveButton-pl41u";
var _a = "popupIndicator-35Cpc";
export { _1 as "__esModule", _2 as "addDocumentModal__modalContent", _3 as "addDocumentModal__modalHeader", _4 as "addDocumentModal__content", _5 as "addDocumentModal__field", _6 as "addDocumentModal__footer", _7 as "addDocumentModal__cancelButton", _8 as "addDocumentModal__clearButton", _9 as "addDocumentModal__saveButton", _a as "popupIndicator" }
export default { "__esModule": _1, "addDocumentModal__modalContent": _2, "addDocumentModal__modalHeader": _3, "addDocumentModal__content": _4, "addDocumentModal__field": _5, "addDocumentModal__footer": _6, "addDocumentModal__cancelButton": _7, "addDocumentModal__clearButton": _8, "addDocumentModal__saveButton": _9, "popupIndicator": _a }
